/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * @format
 */
import { makeAsyncAction } from 'ui-permit/shared-components/utils/async';
import { FETCH_SEASONS } from '../constants/actions';

import * as api from '../api';

export const fetchSeasons = makeAsyncAction(
    FETCH_SEASONS,
    (params) => async () => api.fetchSeasons(params),
    'payload'
);
